module.exports = __webpack_public_path__ + "static/media/halloween-kids.8ecf1094.png";